import React from 'react';
import { Helmet } from 'react-helmet';
import { motion } from 'framer-motion';
import { Calendar, Clock } from 'lucide-react';

const scheduleData = [
  {
    day: "Sabtu, 18 April 2026",
    events: [
      { time: "10:00 - 20:00", title: "Pengambilan Paket Lomba (Semua Kategori)", description: "Lokasi di Purwokerto." },
      { time: "15:30 - 17:30", title: "Technical Meeting (Semua Kategori)", description: "Lokasi di Purwokerto." },
      
      
    ]
  },
  {
    day: "Minggu, 19 April 2026",
    events: [
      { time: "00:01", title: "Start Lomba - BRUTAL 50", description: "Pelepasan peserta kategori 50KM." },
      { time: "05:00", title: "Start Lomba - BANYUMAS 25", description: "Pelepasan peserta kategori 25KM." },
      { time: "06:00", title: "Start Lomba - JUNGLE 15", description: "Pelepasan peserta kategori 15KM." },
      { time: "07:00", title: "Start Lomba - BATURRADEN 7", description: "Pelepasan peserta kategori 7KM." },
      { time: "11:00 - Selesai", title: "Pesta Finisher & Makan Siang", description: "Nikmati hidangan lokal setelah mencapai garis finis." },
      { time: "11:00", title: "Cut-off Time - BATURRADEN 7", description: "Batas waktu akhir untuk kategori 7KM." },
      { time: "12:00", title: "Cut-off Time - JUNGLE 15", description: "Batas waktu akhir untuk kategori 15KM." },
      { time: "13:00", title: "Upacara Penghargaan (50KM, 25KM, 15KM, 7KM)", description: "Pengumuman pemenang." },
      { time: "14:00", title: "Cut-off Time - BANYUMAS 25", description: "Batas waktu akhir untuk kategori 25KM." },
      { time: "15:01", title: "Cut-off Time - BRUTAL 50", description: "Batas waktu akhir untuk kategori 50KM." },      
      { time: "15:00", title: "Acara Penutupan", description: "Sampai jumpa di Banyumas ULtra Series!" },
    ]
  }
];

const SchedulePage = () => {
  return (
    <>
      <Helmet>
        <title>Jadwal Acara - Banyumas Ultra</title>
        <meta name="description" content="Rencanakan akhir pekan lomba Anda dengan jadwal lengkap Banyumas Ultra." />
      </Helmet>
      <div className="bg-background pt-24 sm:pt-32">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="text-center mb-16"
          >
            <Calendar className="mx-auto h-12 w-12 text-primary mb-4" />
            <h1 className="text-4xl md:text-5xl font-black text-foreground">JADWAL ACARA</h1>
            <p className="mt-4 max-w-3xl mx-auto text-lg text-muted-foreground">
              Catat tanggalnya dan jangan lewatkan setiap momen penting dari petualangan ini.
            </p>
          </motion.div>

          <div className="max-w-4xl mx-auto">
            {scheduleData.map((day, dayIndex) => (
              <motion.div
                key={day.day}
                initial={{ opacity: 0, x: -50 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5, delay: dayIndex * 0.2 }}
                className="mb-12"
              >
                <h2 className="text-2xl font-bold text-primary mb-6 border-l-4 border-primary pl-4">{day.day}</h2>
                <div className="relative border-l-2 border-border/50 ml-3">
                  {day.events.map((event, eventIndex) => (
                    <motion.div
                      key={eventIndex}
                      initial={{ opacity: 0, scale: 0.9 }}
                      animate={{ opacity: 1, scale: 1 }}
                      transition={{ duration: 0.5, delay: (dayIndex * 0.2) + (eventIndex * 0.1) }}
                      className="mb-8 ml-8"
                    >
                      <div className="absolute -left-[1.3rem] mt-1.5 h-5 w-5 rounded-full bg-primary border-4 border-background"></div>
                      <div className="flex items-center gap-4 mb-1">
                        <Clock className="h-5 w-5 text-muted-foreground" />
                        <p className="font-mono text-primary">{event.time}</p>
                      </div>
                      <h3 className="text-xl font-semibold text-foreground">{event.title}</h3>
                      <p className="text-muted-foreground">{event.description}</p>
                    </motion.div>
                  ))}
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default SchedulePage;